import {
  FETCH_RVU_REPORT,
  FETCH_RVU_REPORT_SUCCESS,
  FETCH_RVU_REPORT_ERROR,
} from './rvuReport.types'

const INITIAL_STATE = {
  loading: false,
  error: null,
  rvuData: null,
}

const rvuReportReducer = (state = INITIAL_STATE, action) => {
  switch (action.type) {
    case FETCH_RVU_REPORT:
      return { ...state, loading: true, error: null }

    case FETCH_RVU_REPORT_SUCCESS:
      return { ...state, loading: false, rvuData: action.payload }

    case FETCH_RVU_REPORT_ERROR:
      return { ...state, loading: false, error: action.payload }

    default:
      return state
  }
}

export default rvuReportReducer
